import { useEffect } from "react";
import { AUTHENTICATED_ROUTES, ROUTES } from "../configs/routes";
import { Cookie } from "../services/storage";
import {
  REDIRECT,
  REDIRECT_URI,
  REQUEST_NUMBER,
  SHOW_TIMEOUT_DIALOG,
} from "../constants/storage";
import { SP_SPDL_TICKET_NUMBER } from "../constants/ticketNumberRegex";
import { useLoginOptionHooks } from "./login-option-hooks";
import { useQuery } from "./query-hooks";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../store";
import { UserState } from "../store/reducers/user-reducer";
import { useSelector } from "react-redux";
import { LayoutState } from "../store/reducers/layout-reducer";

export const useAuthRouteLoginHandler = (): void => {
  const { toggleLoginModal, removeRedirectSession, handleLoginBasedOnGeoIp } =
    useLoginOptionHooks();
  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );
  const { isLanguageReady } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
  const isLoggedIn = useSelector<ApplicationState, boolean>(
    (state) => state.auth.isLoggedIn
  );
  const history = useHistory();
  const query = useQuery();
  const requestNumberCookie = Cookie.get(REQUEST_NUMBER);
  const redirectUrlParams = query.get("redirect");
  const timeOutDialog = localStorage.getItem(SHOW_TIMEOUT_DIALOG);
  const isTimeOutDialogOpen = timeOutDialog === "true";
  useEffect(() => {
    if (
      !redirectUrlParams ||
      isTimeOutDialogOpen ||
      !isLanguageReady ||
      !userCountryCode
    )
      return () => {};

    // Will validate first if the params.requestNumber is a valid format, if not valid it will redirect to ERROR 404 page
    if (
      requestNumberCookie &&
      !requestNumberCookie.match(SP_SPDL_TICKET_NUMBER) &&
      !isLoggedIn
    ) {
      Cookie.remove(REQUEST_NUMBER);
      history.replace(ROUTES.ERROR_404);
      return () => {};
    }
    // To handle deep links with request details, we will check if it includes "/my-data"
    // This would also affect routes like "/my-data" and "/my-data/history"
    if (
      AUTHENTICATED_ROUTES.includes(redirectUrlParams) ||
      redirectUrlParams.includes(ROUTES.MYDATA)
    ) {
      sessionStorage.setItem(REDIRECT, redirectUrlParams);

      handleLoginBasedOnGeoIp();
    }
    // cleanup function for triggering loginModal
    return () => {
      window.onpopstate = () => {
        window.history.replaceState(null, "", "/");
        removeRedirectSession();
        Cookie.remove(REQUEST_NUMBER);
        Cookie.remove(REDIRECT_URI);
        toggleLoginModal({
          isLoginModalOpen: false,
        });
      };
    };
  }, [
    redirectUrlParams,
    userCountryCode,
    isLanguageReady,
    isTimeOutDialogOpen,
    isLoggedIn,
  ]);
};
